module.exports = "assets/1ac2683cb41532b95f4c258ace62bbc9.glb";